(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["garan-label"] && !Shopify.designMode) return;
  try {
    class GaranLabel extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.handleVariantChange.bind(this);
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    }

    connectedCallback() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          this.append(this.querySelector('template').content);
          observer.disconnect();
        },
        { rootMargin: '200px' }
      );

      observer.observe(this);

      if (this.hasAttribute('data-sync-variant')) {
        this.variantPicker = document.querySelector('.product-main')?.querySelector('variant-picker');
      }

      this.variantPicker?.addEventListener('on:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      this.variantPicker?.removeEventListener('on:variant:change', this.onVariantChange);
    }

    handleClick(event) {
      if (!event.target.closest('modal-opener')) {
        return;
      }

      this.fillModal();
    }

    handleTransitionEnd(event) {
      const modal = event.target;
      if (event.propertyName !== 'visibility' || !modal.matches('modal-dialog') || modal.hasAttribute('open')) {
        return;
      }

      modal.querySelector('[data-modal-content]')?.replaceChildren();
    }

    fillModal() {
      const content = this.querySelector('[data-modal-content]');
      const template = document.getElementById('garan-label-template');
      if (!content || !template || content.hasChildNodes()) {
        return;
      }

      content.append(template.content.cloneNode(true));

      const identifierEl = content.querySelector('[data-identifier]');
      if (identifierEl) {
        identifierEl.textContent = this.dataset.identifier;
      }

      const yearsEl = content.querySelector('[data-years]');
      if (yearsEl) {
        yearsEl.textContent = this.dataset.years;
      }
    }

    handleVariantChange(event) {
      if (!event.detail.variant?.sku) {
        return;
      }

      this.dataset.identifier = event.detail.variant.sku;

      const identifierEl = this.querySelector('[data-identifier]');
      if (!identifierEl) {
        return;
      }

      identifierEl.textContent = event.detail.variant.sku;
    }
  }

  if (!customElements.get('garan-label')) {
    customElements.define('garan-label', GaranLabel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-bundle"] && !Shopify.designMode) return;
  try {
    class BundleProductSelectionHelper extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange(event) {
      const input = event.target.closest('input[type="radio"][data-product-handle]');

      if (!input) {
        return;
      }

      this.selectProduct(input.dataset.productHandle, { silent: false });
    }

    selectProduct(handle, options = {}) {
      const input = Array.from(this.querySelectorAll('input[type="radio"][data-product-handle]')).find(
        (productInput) => productInput.dataset.productHandle === handle
      );

      if (!input) {
        return;
      }

      input.checked = true;

      if (options.silent) {
        return;
      }

      this.dispatchEvent(
        new CustomEvent('bundle:product-switch', {
          bubbles: true,
          detail: {
            handle: input.dataset.productHandle,
            productId: input.value,
          },
        })
      );
    }
  }

  if (!customElements.get('bundle-product-selection-helper')) {
    customElements.define('bundle-product-selection-helper', BundleProductSelectionHelper);
  }

  class BundleSummaryHelper extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.querySelectorAll('[data-bundle-summary-edit-step]').forEach((button) => {
        button.addEventListener('click', this.handleClick);
      });
    }

    disconnectedCallback() {
      this.querySelectorAll('[data-bundle-summary-edit-step]').forEach((button) => {
        button.removeEventListener('click', this.handleClick);
      });
    }

    handleClick(event) {
      const editButton = event.currentTarget;

      if (!editButton) {
        return;
      }

      this.dispatchEvent(
        new CustomEvent('bundle:summary-edit', {
          bubbles: true,
          detail: {
            stepIndex: Number(editButton.dataset.bundleSummaryEditStep),
          },
        })
      );
    }
  }

  if (!customElements.get('bundle-summary-helper')) {
    customElements.define('bundle-summary-helper', BundleSummaryHelper);
  }

  class BundleComponent extends HTMLElement {
    constructor() {
      super();
      this.started = false;
      this.currentStepIndex = -1;
      this.bundleData = null;
      this.selectionsByPartId = {};
      this.viewedStepIndexes = new Set();
      this.productsSelectorMarkupByPartId = new Map();
      this.productMarkupByHandle = new Map();
      this.summaryMarkupBySelections = new Map();

      this.handleStartClick = this.handleStartClick.bind(this);
      this.handleNavActions = this.handleNavActions.bind(this);
      this.handleStepButtonClick = this.handleStepButtonClick.bind(this);
      this.handleProductChange = this.handleProductChange.bind(this);
      this.handleSummaryEdit = this.handleSummaryEdit.bind(this);
      this.handleForcedOptionClick = this.handleForcedOptionClick.bind(this);
      this.hydrateInjectedImages = this.hydrateInjectedImages.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.disableInjectedVariantPickerUrlUpdates = this.disableInjectedVariantPickerUrlUpdates.bind(this);
      this.handleBundleFormSubmit = this.handleBundleFormSubmit.bind(this);
      this.parseBundleData = this.parseBundleData.bind(this);
      this.ensureBundleKey = this.ensureBundleKey.bind(this);
      this.generateBundleKey = this.generateBundleKey.bind(this);
      this.scrollReviewStepIntoView = this.scrollReviewStepIntoView.bind(this);
      this.setBundleErrorState = this.setBundleErrorState.bind(this);
      this.setHiddenInputSelectedVariantForPart = this.setHiddenInputSelectedVariantForPart.bind(this);
      this.updateBundlePrice = this.updateBundlePrice.bind(this);
      this.getSelectedProductAndVariantPairs = this.getSelectedProductAndVariantPairs.bind(this);
    }

    connectedCallback() {
      this.introLayout = this.querySelector('#BundleIntroLayout');
      this.errorBanner = this.querySelector('.js-bundle-error');
      this.stepsHeaderHolder = this.querySelector('#BundleStepsHeader');
      this.productSelectorHolder = this.querySelector('#BundleProductSelector');
      this.stepActionsHolder = this.querySelector('#BundleStepActions');
      this.bundleContent = this.querySelector('#BundleContent');
      this.bundleForm = this.querySelector('#BundleForm');
      if (
        !this.introLayout ||
        !this.errorBanner ||
        !this.stepsHeaderHolder ||
        !this.productSelectorHolder ||
        !this.stepActionsHolder ||
        !this.bundleContent ||
        !this.bundleForm
      ) {
        console.error('Bundle component is missing required elements');
        return;
      }

      this.bundleForm.addEventListener('submit', this.handleBundleFormSubmit);
      this.addEventListener('click', this.handleNavActions);
      this.addEventListener('click', this.handleForcedOptionClick, true);
      this.addEventListener('bundle:product-switch', this.handleProductChange);
      this.addEventListener('bundle:summary-edit', this.handleSummaryEdit);
      this.addEventListener('on:variant:change', this.handleVariantChange);
      this.bundleData = this.parseBundleData();
    }

    disconnectedCallback() {
      this.bundleForm.removeEventListener('submit', this.handleBundleFormSubmit);
      this.removeEventListener('click', this.handleNavActions);
      this.removeEventListener('click', this.handleForcedOptionClick, true);
      this.removeEventListener('bundle:product-switch', this.handleProductChange);
      this.removeEventListener('bundle:summary-edit', this.handleSummaryEdit);
      this.removeEventListener('on:variant:change', this.handleVariantChange);
    }

    parseBundleData() {
      const bundleDataElement = this.querySelector('#BundleData');

      if (!bundleDataElement) {
        return null;
      }

      try {
        return JSON.parse(bundleDataElement.textContent);
      } catch (error) {
        console.error('Failed to parse bundle data', error);
        this.setBundleErrorState(window.Bundles.Translations.error);
        return null;
      }
    }

    async handleBundleFormSubmit(event) {
      event.preventDefault();

      if (!this.canSubmitBundle()) {
        this.promptForcedOptionSelection();
        return;
      }

      this.ensureBundleKey();

      const addToCartButton = this.querySelector('[data-bundle-add-to-cart]');
      const cartDrawer = document.querySelector('cart-drawer');

      if (addToCartButton) {
        addToCartButton.setAttribute('aria-disabled', 'true');
        addToCartButton.classList.add('is-loading');
      }

      const formData = new FormData(this.bundleForm);
      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
          const errorMsg = typeof data.description === 'string' ? data.description : data.message;
          this.setBundleErrorState(errorMsg || window.Bundles.Translations.error);
          return;
        }

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
            cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
          }

          setTimeout(() => {
            if (cartDrawer) {
              cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
            }
          }, 700);
        }
      } catch (error) {
        console.error('Bundle add to cart failed', error);
        this.setBundleErrorState(window.Bundles.Translations.error);
      } finally {
        if (addToCartButton) {
          addToCartButton.classList.add('is-success');
          addToCartButton.removeAttribute('aria-disabled');
          setTimeout(() => {
            addToCartButton.classList.remove('is-loading');
            addToCartButton.classList.remove('is-success');
          }, 1400);
        }
      }
    }

    ensureBundleKey() {
      if (!this.bundleForm) {
        return '';
      }

      let bundleKey = this.bundleForm.dataset.bundleKey;

      if (!bundleKey) {
        bundleKey = this.generateBundleKey();
        this.bundleForm.dataset.bundleKey = bundleKey;
      }

      this.querySelectorAll('input[name$="properties[_bundle_key]"]').forEach((input) => {
        input.value = bundleKey;
      });

      return bundleKey;
    }

    generateBundleKey() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return `bundle-${Date.now()}-${window.crypto.randomUUID()}`;
      }

      return `bundle-${Date.now()}-${Math.floor(Math.random() * 1000000000)}`;
    }

    async handleStartClick() {
      if (!this.bundleData || !Array.isArray(this.bundleData.parts) || this.bundleData.parts.length === 0) {
        return;
      }

      if (this.started) {
        return;
      }

      this.started = true;

      const startButton = this.querySelector('#BundleStartButton');
      if (startButton) {
        startButton.setAttribute('aria-disabled', 'true');
        startButton.classList.add('is-loading');
      }

      await this.prefetchStep(0);

      this.introLayout.hidden = true;
      await this.openStep(0);

      if (startButton) {
        startButton.classList.remove('is-loading');
        startButton.removeAttribute('aria-disabled');
      }
    }

    handleNavActions(event) {
      const startButton = event.target.closest('#BundleStartButton');
      if (startButton) {
        this.handleStartClick();
        return;
      }

      const stepButton = event.target.closest('[data-bundle-step-index]');
      if (stepButton) {
        const index = Number(stepButton.dataset.bundleStepIndex);
        if (this.canOpenStep(index)) {
          this.handleStepButtonClick(stepButton, index);
        }
        return;
      }

      const nextButton = event.target.closest('[data-bundle-next-step]');
      if (nextButton) {
        this.handleNextStepClick();
      }
    }

    async handleStepButtonClick(button, index) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      await this.prefetchStep(index);
      await this.openStep(index);
    }

    getTotalSteps() {
      return this.getProductStepCount() + 1;
    }

    getProductStepCount() {
      if (!this.bundleData || !Array.isArray(this.bundleData.parts)) {
        return 0;
      }

      return this.bundleData.parts.length;
    }

    getReviewStepIndex() {
      return this.getProductStepCount();
    }

    isReviewStep(stepIndex = this.currentStepIndex) {
      return stepIndex === this.getReviewStepIndex();
    }

    getPartByStepIndex(stepIndex) {
      if (!this.bundleData || !Array.isArray(this.bundleData.parts)) {
        return null;
      }

      return this.bundleData.parts[stepIndex] || null;
    }

    getCurrentPart() {
      return this.getPartByStepIndex(this.currentStepIndex);
    }

    getSelectedProductHandleForStep(stepIndex = this.currentStepIndex) {
      const part = this.getPartByStepIndex(stepIndex);

      if (!part || !Array.isArray(part.products) || part.products.length === 0) {
        return '';
      }

      // TODO: out of stock?
      return this.getSelectedProductForPart(part)?.handle || '';
    }

    getSelectionForPart(partId) {
      if (!this.selectionsByPartId[partId]) {
        this.selectionsByPartId[partId] = {
          productId: null,
          variantId: null,
          forceOptionSelected: false,
        };
      }

      return this.selectionsByPartId[partId];
    }

    getSelectedProductForPart(part) {
      if (!part || !Array.isArray(part.products) || part.products.length === 0) {
        return null;
      }

      const selectedProductId = this.getSelectionForPart(part.id).productId;

      return part.products.find((product) => String(product.id) === String(selectedProductId)) || part.products[0];
    }

    getSelectedVariantIdForPart(partId) {
      return this.getSelectionForPart(partId).variantId;
    }

    getVariantById(part, variantId) {
      if (!part || !variantId) {
        return null;
      }

      for (const product of part.products || []) {
        const variant = (product.variants || []).find(
          (productVariant) => String(productVariant.id) === String(variantId)
        );

        if (variant) {
          return variant;
        }
      }

      return null;
    }

    async updateBundlePrice() {
      const priceElement = this.bundleContent?.querySelector('[data-bundle-price]');

      if (!priceElement) {
        return;
      }

      const selections = this.getSelectedProductAndVariantPairs();
      const productHandle = this.bundleData?.productHandle || '';
      const priceQuery = productHandle ? `${selections.join(',')}||${productHandle}` : selections.join(',');

      const res = await fetch(
        `${Shopify.routes.root}search?q=${encodeURIComponent(priceQuery)}&section_id=bundle-price-helper`
      );
      if (!res.ok) {
        console.error('Failed to fetch bundle price helper', res.status);
        return;
      }

      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('.shopify-section');
      if (section?.innerHTML?.trim()) {
        priceElement.innerHTML = section.innerHTML;
      }
    }

    getSelectedProductAndVariantPairs() {
      if (!this.bundleData || !Array.isArray(this.bundleData.parts)) {
        return [];
      }

      return this.bundleData.parts
        .map((part) => {
          const selectedProduct = this.getSelectedProductForPart(part);
          const variantId = this.getSelectedVariantIdForPart(part.id);

          if (!selectedProduct || !variantId) {
            return '';
          }

          return `${selectedProduct.handle}:${variantId}`;
        })
        .filter(Boolean);
    }

    getProductHandlesForPart(part) {
      if (!part || !Array.isArray(part.products)) {
        return [];
      }

      return part.products.map((product) => product.handle).filter(Boolean);
    }

    getMaxViewedStepIndex() {
      if (this.viewedStepIndexes.size === 0) {
        return -1;
      }

      return Math.max(...this.viewedStepIndexes);
    }

    canOpenStep(stepIndex) {
      if (stepIndex < 0 || stepIndex >= this.getProductStepCount()) {
        return false;
      }

      return stepIndex <= this.getMaxViewedStepIndex();
    }

    canAdvanceFromCurrentStep() {
      if (this.isReviewStep()) {
        return this.areAllPartsComplete();
      }

      const currentPart = this.getCurrentPart();

      if (!currentPart) {
        return false;
      }

      return this.isPartComplete(currentPart);
    }

    areAllPartsComplete() {
      if (!this.bundleData || !Array.isArray(this.bundleData.parts)) {
        return false;
      }

      return this.bundleData.parts.every((part) => this.isPartComplete(part));
    }

    canSubmitBundle() {
      return this.areAllPartsComplete();
    }

    async handleNextStepClick() {
      if (!this.canAdvanceFromCurrentStep()) {
        this.promptForcedOptionSelection();
        return;
      }

      const nextStepIndex = this.currentStepIndex + 1;

      if (nextStepIndex >= this.getTotalSteps()) {
        return;
      }

      const nextButton = this.querySelector('[data-bundle-next-step]');
      if (nextButton) {
        nextButton.setAttribute('aria-disabled', 'true');
        nextButton.classList.add('is-loading');
      }

      await this.prefetchStep(nextStepIndex);
      await this.openStep(nextStepIndex);
    }

    async prefetchStep(stepIndex) {
      if (this.isReviewStep(stepIndex)) {
        await this.fetchSummaryMarkup();
        return;
      }

      const part = this.getPartByStepIndex(stepIndex);

      if (!part) {
        return;
      }

      const handle = this.getSelectedProductHandleForStep(stepIndex);

      await Promise.all([
        handle ? this.fetchProductSectionMarkup(handle) : Promise.resolve(),
        this.fetchProductSelectorMarkup(part),
      ]);
    }

    async handleProductChange(event) {
      const currentPart = this.getCurrentPart();
      const handle = event.detail?.handle;
      const product = currentPart?.products?.find((partProduct) => partProduct.handle === handle);

      if (!currentPart || !product || handle === this.getSelectedProductHandleForStep()) {
        return;
      }

      this.getSelectionForPart(currentPart.id).productId = product.id;
      this.setHiddenInputSelectedVariantForPart(currentPart.id, null);
      await this.renderCurrentStep();
    }

    async handleSummaryEdit(event) {
      const stepIndex = event.detail?.stepIndex;

      if (!Number.isInteger(stepIndex) || stepIndex < 0 || stepIndex >= this.getProductStepCount()) {
        return;
      }

      await this.prefetchStep(stepIndex);
      await this.openStep(stepIndex);
    }

    async openStep(stepIndex) {
      const targetPart = this.getPartByStepIndex(stepIndex);

      if (!targetPart && !this.isReviewStep(stepIndex)) {
        return;
      }

      this.currentStepIndex = stepIndex;
      this.viewedStepIndexes.add(stepIndex);
      await this.renderCurrentStep();
    }

    async renderCurrentStep() {
      if (this.isReviewStep()) {
        await this.renderSummaryStep();
        return;
      }

      const currentPart = this.getCurrentPart();

      if (!currentPart) {
        return;
      }

      const handle = this.getSelectedProductHandleForStep();

      try {
        const markup = await this.fetchProductSectionMarkup(handle);

        if (!markup) {
          this.setBundleErrorState(window.Bundles.Translations.error);
          return;
        }

        this.setBundleErrorState(false);
        this.setAttribute('data-bundle-state', 'step');
        this.moveStepControlsToHolders();
        this.introLayout.hidden = true;
        this.bundleContent.hidden = false;
        this.bundleContent.innerHTML = markup;
        await this.afterStepContentInjected();
      } catch (error) {
        console.error('Failed to open bundle step', error);
        this.setBundleErrorState(window.Bundles.Translations.error);
      }
    }

    async renderSummaryStep() {
      try {
        const markup = await this.fetchSummaryMarkup();
        const summaryTarget = this.querySelector('[data-bundle-review-summary]');

        if (!markup || !summaryTarget) {
          this.setBundleErrorState(window.Bundles.Translations.error);
          return;
        }

        this.setBundleErrorState(false);
        this.classList.remove('bundle-force-select-pending');
        this.classList.remove('bundle-force-select-required');
        this.setAttribute('data-bundle-state', 'review');
        this.moveStepControlsToHolders();
        this.introLayout.hidden = false;
        this.bundleContent.hidden = true;
        this.bundleContent.innerHTML = '';
        summaryTarget.innerHTML = markup;
        this.hydrateInjectedImages();
        this.injectStepControls();
        this.updateStepControls();
        this.scrollReviewStepIntoView();
      } catch (error) {
        console.error('Failed to open bundle summary', error);
        this.setBundleErrorState(window.Bundles.Translations.error);
      }
    }

    scrollReviewStepIntoView() {
      window.requestAnimationFrame(() => {
        const target = this.querySelector('.bundle-summary-helper') || this.querySelector('.bundle-summary-helper');

        if (!target) {
          return;
        }

        const contentStart = parseFloat(
          window.getComputedStyle(document.documentElement).getPropertyValue('--content-start')
        );
        const scrollOffset = Number.isFinite(contentStart) ? contentStart : 120;
        const top = Math.max(window.scrollY + target.getBoundingClientRect().top - scrollOffset, 0);
        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      });
    }

    async fetchProductSectionMarkup(handle) {
      if (this.productMarkupByHandle.has(handle)) {
        return this.productMarkupByHandle.get(handle);
      }

      const response = await fetch(`${Shopify.routes.root}products/${handle}?view=bundle-part`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const productSection =
        doc.querySelector('#main-content .shopify-section') || doc.querySelector('.shopify-section');

      if (!productSection) {
        return '';
      }

      const markup = productSection.innerHTML;
      this.productMarkupByHandle.set(handle, markup);

      return markup;
    }

    async fetchSummaryMarkup() {
      const selections = this.getSelectedProductAndVariantPairs();

      if (selections.length !== this.getProductStepCount()) {
        return '';
      }

      const productHandle = this.bundleData?.productHandle || '';
      const selectionsKey = productHandle ? `${selections.join(',')}||${productHandle}` : selections.join(',');

      if (this.summaryMarkupBySelections.has(selectionsKey)) {
        return this.summaryMarkupBySelections.get(selectionsKey);
      }

      const response = await fetch(
        `${Shopify.routes.root}search?q=${encodeURIComponent(selectionsKey)}&sections=bundle-summary-helper`
      );
      const sections = await response.json();
      const markup = sections['bundle-summary-helper'] || '';

      this.summaryMarkupBySelections.set(selectionsKey, markup);
      return markup;
    }

    async afterStepContentInjected() {
      this.disableInjectedVariantPickerUrlUpdates();
      this.hydrateInjectedImages();
      this.injectStepControls();
      await this.injectProductSelector();
      this.restoreSelectedVariantForCurrentProduct();
      this.updateCurrentStepHeaderImageFromVariantPicker();
      this.updateForcedOptionPendingState();
      this.updateStepControls();
    }

    getForcedOptionName() {
      return (this.dataset.forceSelectOptionName || '').trim();
    }

    getForcedOptionValueContainer() {
      const forcedOptionName = this.getForcedOptionName();

      if (!forcedOptionName || !this.bundleContent) {
        return null;
      }

      return this.bundleContent.querySelector(`[data-opt-name="${CSS.escape(forcedOptionName)}"]`);
    }

    isPartComplete(part) {
      return Boolean(part && this.getSelectedVariantIdForPart(part.id) && this.isForceSelectCompleteForPart(part));
    }

    isForceSelectCompleteForPart(part) {
      if (part === this.getCurrentPart() && !this.getForcedOptionValueContainer()) {
        return true;
      }

      return Boolean(this.getSelectionForPart(part.id).forceOptionSelected);
    }

    updateForcedOptionPendingState() {
      const currentPart = this.getCurrentPart();
      const forcedOptionValueContainer = this.getForcedOptionValueContainer();
      const selection = currentPart ? this.getSelectionForPart(currentPart.id) : null;

      if (selection && !forcedOptionValueContainer) {
        selection.forceOptionSelected = true;
      }

      this.classList.toggle(
        'bundle-force-select-pending',
        Boolean(currentPart && forcedOptionValueContainer && !this.isForceSelectCompleteForPart(currentPart))
      );
    }

    handleForcedOptionClick(event) {
      const currentPart = this.getCurrentPart();
      const forcedOptionValueContainer = this.getForcedOptionValueContainer();
      const optionControl = event.target.closest('input.js-option, .opt-label, .custom-select__option');

      if (
        !currentPart ||
        !forcedOptionValueContainer ||
        !optionControl ||
        !forcedOptionValueContainer.contains(optionControl)
      ) {
        return;
      }

      this.getSelectionForPart(currentPart.id).forceOptionSelected = true;
      this.updateForcedOptionPendingState();
      this.updateStepControls();
    }

    promptForcedOptionSelection() {
      if (!this.classList.contains('bundle-force-select-pending')) {
        return;
      }

      const forcedOptionValueContainer = this.getForcedOptionValueContainer();

      if (!forcedOptionValueContainer) {
        return;
      }

      forcedOptionValueContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.classList.remove('bundle-force-select-required');

      window.requestAnimationFrame(() => {
        this.classList.add('bundle-force-select-required');
      });

      window.clearTimeout(this.forceSelectRequiredTimer);
      this.forceSelectRequiredTimer = window.setTimeout(() => {
        this.classList.remove('bundle-force-select-required');
      }, 1600);
    }

    injectStepControls() {
      const stepsHeader = this.querySelector('[data-bundle-steps-header]');
      const stepActions = this.querySelector('[data-bundle-step-actions]');

      if (this.isReviewStep()) {
        return;
      }

      if (!stepsHeader || !stepActions) {
        return;
      }

      const injectionTarget = this.getStepInjectionTarget();

      if (!injectionTarget) {
        return;
      }

      injectionTarget.prepend(stepsHeader);
      injectionTarget.append(stepActions);
    }

    async injectProductSelector() {
      const stepsHeader = this.querySelector('[data-bundle-steps-header]');
      const productSelector = await this.getCurrentProductSelector();

      if (!stepsHeader || !productSelector) {
        return;
      }

      productSelector.selectProduct(this.getSelectedProductHandleForStep(), { silent: true });
      stepsHeader.after(productSelector);
    }

    updateCurrentStepHeaderImageFromVariantPicker() {
      const variantPicker = this.bundleContent.querySelector('variant-picker');
      this.updateStepHeaderImage(this.currentStepIndex, variantPicker?.variant);
    }

    updateStepHeaderImage(stepIndex, variant) {
      const part = this.getPartByStepIndex(stepIndex);
      const imageSrc = this.getVariantFeaturedImageSrc(variant) || this.getSelectedProductForPart(part)?.featuredImage;

      if (!imageSrc) {
        return;
      }

      const stepImage = this.querySelector(`[data-bundle-step-index="${stepIndex}"] [data-bundle-step-image]`);

      if (!stepImage) {
        return;
      }

      stepImage.src = imageSrc;
      stepImage.hidden = false;
    }

    getVariantFeaturedImageSrc(variant) {
      return (
        variant?.featured_media?.preview_image?.src ||
        variant?.featured_media?.src ||
        variant?.featured_image?.src ||
        variant?.image?.src ||
        ''
      );
    }

    restoreSelectedVariantForCurrentProduct() {
      const currentPart = this.getCurrentPart();

      if (!currentPart) {
        return;
      }

      const selectedVariantId = this.getSelectedVariantIdForPart(currentPart.id);

      if (selectedVariantId && this.selectVariantInVariantPicker(selectedVariantId)) {
        return;
      }

      const variantPicker = this.bundleContent.querySelector('variant-picker');
      const pickerVariant = variantPicker?.variant;
      const variantId =
        (pickerVariant?.available ? pickerVariant.id : null) ||
        this.bundleContent.querySelector('.js-product-form-main input[name="id"]')?.value ||
        (variantPicker ? null : this.getDefaultVariantIdForPart(currentPart));

      if (!variantId) {
        this.setHiddenInputSelectedVariantForPart(currentPart.id, null);
        return;
      }

      this.selectVariantForPart(currentPart.id, variantId);
    }

    /**
     * Resolves a variant from the bundle data for parts whose selected product
     * has no variant picker in the injected markup.
     */
    getDefaultVariantIdForPart(part) {
      const product = this.getSelectedProductForPart(part);

      if (!product || !Array.isArray(product.variants)) {
        return null;
      }

      const preferredVariant = product.variants.find(
        (variant) => String(variant.id) === String(product.selectedOrFirstAvailableVariantId) && variant.available
      );

      if (preferredVariant) {
        return preferredVariant.id;
      }

      return product.variants.find((variant) => variant.available)?.id || null;
    }

    selectVariantInVariantPicker(variantId) {
      const variantPicker = this.bundleContent.querySelector('variant-picker');

      if (!variantPicker || !variantPicker.data?.product?.variants) {
        return false;
      }

      const variant = variantPicker.data.product.variants.find(
        (productVariant) => String(productVariant.id) === String(variantId)
      );

      if (!variant) {
        return false;
      }

      let changedInput = null;

      variant.options.forEach((optionValue, optionIndex) => {
        const selector = variantPicker.optionSelectors[optionIndex];

        if (!selector) {
          return;
        }

        const optionInput = Array.from(selector.querySelectorAll('input.js-option')).find(
          (input) => input.value === optionValue
        );

        if (optionInput) {
          optionInput.checked = true;
          changedInput = optionInput;
        }
      });

      if (!changedInput) {
        return false;
      }

      changedInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    async getCurrentProductSelector() {
      const currentPart = this.getCurrentPart();

      if (!currentPart) {
        return null;
      }

      const selectorMarkup = await this.fetchProductSelectorMarkup(currentPart);

      if (!selectorMarkup) {
        return null;
      }

      this.productSelectorHolder.innerHTML = selectorMarkup;
      const productSelector = this.productSelectorHolder.querySelector('bundle-product-selection-helper');
      const legend = productSelector?.querySelector('.bundle-product-selection-helper__legend');

      if (legend && currentPart.title) {
        legend.textContent = (window.Bundles.Translations.chooseStep || '').replace('{step}', currentPart.title);
      }

      return productSelector;
    }

    async fetchProductSelectorMarkup(part) {
      if (this.productsSelectorMarkupByPartId.has(part.id)) {
        return this.productsSelectorMarkupByPartId.get(part.id);
      }

      const handles = this.getProductHandlesForPart(part);

      if (handles.length === 0) {
        return '';
      }

      const handlesQuery = handles.map((handle) => encodeURIComponent(handle)).join(',');
      const response = await fetch(
        `${Shopify.routes.root}search?q=${handlesQuery}&sections=bundle-product-selection-helper`
      );
      const sections = await response.json();
      const markup = sections['bundle-product-selection-helper'] || '';

      this.productsSelectorMarkupByPartId.set(part.id, markup);
      return markup;
    }

    getStepInjectionTarget() {
      return (
        this.bundleContent.querySelector('.product-info__sticky') ||
        this.bundleContent.querySelector('.product-info') ||
        this.bundleContent.querySelector('.bundle-summary-helper__card')
      );
    }

    updateStepControls() {
      this.querySelectorAll('[data-bundle-step-index]').forEach((button) => {
        const index = Number(button.dataset.bundleStepIndex);
        const part = this.getPartByStepIndex(index);
        button.disabled = !this.canOpenStep(index);
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        button.classList.toggle('is-current', index === this.currentStepIndex);
        button.classList.toggle('is-complete', this.isPartComplete(part));

        if (index === this.currentStepIndex) {
          button.setAttribute('aria-current', 'step');
        } else {
          button.removeAttribute('aria-current');
        }

        button.querySelectorAll('[data-bundle-step-image]').forEach((el) => {
          el.hidden = false;
        });
      });

      const nextButton = this.querySelector('[data-bundle-next-step]');
      const nextButtonText = this.querySelector('[data-bundle-next-step-text]');
      const addToCartButton = this.querySelector('[data-bundle-add-to-cart]');

      if (!nextButton || !nextButtonText || !addToCartButton) {
        return;
      }

      nextButton.classList.remove('is-loading');
      nextButton.removeAttribute('aria-disabled');
      addToCartButton.removeAttribute('aria-disabled');

      const isReviewStep = this.isReviewStep();
      nextButton.hidden = isReviewStep;
      addToCartButton.hidden = !isReviewStep;
      const isForceBlocked = this.classList.contains('bundle-force-select-pending');

      if (isReviewStep) {
        addToCartButton.disabled = !this.canAdvanceFromCurrentStep() && !isForceBlocked;
        if (isForceBlocked) {
          addToCartButton.setAttribute('aria-disabled', 'true');
        }
        this.updateBundlePrice();
        return;
      }

      const nextStepIndex = this.currentStepIndex + 1;
      const nextPart = this.getPartByStepIndex(nextStepIndex);
      nextButton.disabled = !this.canAdvanceFromCurrentStep() && !isForceBlocked;
      if (isForceBlocked) {
        nextButton.setAttribute('aria-disabled', 'true');
      }
      if (this.isReviewStep(nextStepIndex)) {
        nextButtonText.textContent = window.Bundles.Translations.review;
      } else {
        nextButtonText.textContent = nextPart
          ? `${window.Bundles.Translations.next} - ${nextPart.title}`
          : window.Bundles.Translations.next;
      }
      this.updateBundlePrice();
    }

    moveStepControlsToHolders() {
      const stepsHeader = this.querySelector('[data-bundle-steps-header]');
      const productSelector = this.querySelector('bundle-product-selection-helper');
      const stepActions = this.querySelector('[data-bundle-step-actions]');

      if (stepsHeader) {
        this.stepsHeaderHolder.append(stepsHeader);
      }

      if (productSelector) {
        this.productSelectorHolder.append(productSelector);
      }

      if (stepActions) {
        this.stepActionsHolder.append(stepActions);
      }
    }

    setBundleErrorState(error = false) {
      this.errorBanner.hidden = !error;
      this.errorBanner.textContent = error || '';
    }

    hydrateInjectedImages() {
      this.bundleContent.querySelectorAll('img').forEach((image) => {
        if (typeof setImageSources === 'function') {
          setImageSources(image);
        }
      });

      if (typeof initLazyImages === 'function') {
        initLazyImages();
      }
    }

    disableInjectedVariantPickerUrlUpdates() {
      this.bundleContent.querySelectorAll('variant-picker').forEach((variantPicker) => {
        variantPicker.dataset.updateUrl = 'false';
      });
    }

    async handleVariantChange(event) {
      if (!this.bundleContent.contains(event.target)) {
        return;
      }

      const currentPart = this.getCurrentPart();

      if (!currentPart) {
        return;
      }

      if (event.detail?.variant) {
        this.updateStepHeaderImage(this.currentStepIndex, event.detail.variant);
      }

      if (event.detail?.variant?.available) {
        this.selectVariantForPart(currentPart.id, event.detail.variant.id);
      } else {
        this.setHiddenInputSelectedVariantForPart(currentPart.id, null);
      }

      this.updateStepControls();
    }

    /**
     * Updates the selection storage and the hidden input
     * when a variant is selected.
     */
    selectVariantForPart(partId, variantId) {
      const selection = this.getSelectionForPart(partId);

      if (!selection.productId) {
        const part = this.bundleData?.parts?.find((bundlePart) => bundlePart.id === partId);
        const product = this.getSelectedProductForPart(part);
        selection.productId = product?.id || null;
      }

      selection.variantId = variantId;
      this.setHiddenInputSelectedVariantForPart(partId, variantId);
    }

    /**
     * Sets the variant ID in the hidden input for that part.
     * Disables the input if no variant is selected.
     */
    setHiddenInputSelectedVariantForPart(partId, variantId) {
      const partInputs = this.bundleForm.querySelectorAll(`[data-part-id="${partId}"]`);
      const hasVariant = Boolean(variantId);
      this.getSelectionForPart(partId).variantId = hasVariant ? variantId : null;

      partInputs.forEach((input) => {
        input.disabled = !hasVariant;

        if (input.name.endsWith('id')) {
          input.value = hasVariant ? variantId : '';
        }
      });
    }
  }

  if (!customElements.get('bundle-component')) {
    customElements.define('bundle-component', BundleComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
